// extracted by mini-css-extract-plugin
module.exports = {"form":"fj","isSubmitting":"fk","row":"fl","column":"fm","warning":"fn"};